export function hasTimestampExpired(
	timestamp: number | null | undefined,
	diff: number
): boolean {
	return timestamp == null || Date.now() - timestamp >= diff
}
